export type Address = {
    name: string;
    label: string;
    municipalityName: string;
    postalCode: string;
    lat: number;
    lon: number;
};

export enum PropertyType {
    FLAT = 'FLAT',
    TERRACED_SEMIDETACHED = 'TERRACED_SEMIDETACHED',
    DETACHED = 'DETACHED',
}

export type InputFormData = {
    size?: string;
    address?: Address;
    propertyType?: PropertyType;
    floor?: string;
    bedrooms?: string;
};

export interface FormErrors {
    address?: string;
    propertyType?: string;
    size?: string;
    floor?: string;
    bedrooms?: string;
}

export function createInputFormDataFromFormData(formData: FormData): InputFormData {
    return {
        size: formData.get('size') as string,
        address: {
            name: formData.get('address.name') as string,
            label: formData.get('address.label') as string,
            municipalityName: formData.get('address.municipalityName') as string,
            postalCode: formData.get('address.postalCode') as string,
            lat: Number.parseFloat(formData.get('address.lat') as string) || 0,
            lon: Number.parseFloat(formData.get('address.lon') as string) || 0,
        },
        propertyType: formData.get('propertyType') as PropertyType,
        floor: formData.get('floor') as string,
        bedrooms: formData.get('bedrooms') as string,
    };
}
